import { ApolloClient, InMemoryCache } from "@apollo/client";
import { API_URL } from '@app/config';

const client = new ApolloClient({
    name: 'social-media-connect-front',
    uri: `${API_URL}graphql`,
    cache: new InMemoryCache(),
});

export default client;